import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { faTasksAlt } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { TasksPageRoute } from '@/routes/tasks/TasksPage.route'

export const TaskReminderRoute: TileRoleRoute = {
  path: 'taskreminder',
  text: 'Promemoria Task',
  faIcon: faTasksAlt,
  element: (
    <ManagementGridFactory
      entity={'stato_promemoria_task'}
      referencesCollection={'tasks'}
      referencesTitle={'Promemoria Task'}
      displayField={'ded_Dis'}
      entityRoute={TasksPageRoute.path as string}
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Promemoria Task',
      icon: faTasksAlt,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
